import { DateTime } from "luxon";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { useSchedulingStep } from "../../../hooks/use-scheduling-step";

interface MobileSchedulingStepProps {
  schedulingStep: ReturnType<typeof useSchedulingStep>;
  loading?: boolean;
}

export function MobileSchedulingStep({
  schedulingStep,
  loading = false,
}: MobileSchedulingStepProps) {
  const { date, time, notes, setNotes, handleDateChange, handleTimeChange, handleTimeBlur } =
    schedulingStep;

  return (
    <div className="space-y-4">
      <div>
        <h3 className="text-lg font-semibold mb-4">Schedule & Details</h3>

        <div className="space-y-4">
          <div>
            <Label htmlFor="date">Date *</Label>
            <Input
              id="date"
              type="date"
              value={date ? date.toFormat("yyyy-MM-dd") : ""}
              onChange={(e) => {
                if (e.target.value) {
                  const selectedDate = DateTime.fromISO(e.target.value).toJSDate();
                  handleDateChange(selectedDate);
                } else {
                  handleDateChange(undefined);
                }
              }}
              min={DateTime.now().toFormat("yyyy-MM-dd")}
              className="mt-1 h-12"
              disabled={loading}
            />
          </div>

          <div>
            <Label htmlFor="time">Time *</Label>
            <Input
              id="time"
              type="time"
              value={time}
              onChange={(e) => handleTimeChange(e.target.value)}
              onBlur={(e) => handleTimeBlur(e.target.value)}
              className="mt-1 h-12"
              disabled={loading}
            />
          </div>

          <div>
            <Label htmlFor="notes">Notes</Label>
            <Textarea
              id="notes"
              value={notes}
              onChange={(e) => setNotes(e.target.value)}
              className="mt-1"
              placeholder="Any special requests or notes..."
              disabled={loading}
              rows={3}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
